import { PdfViewer } from '@icims-design-system/mui-core';
import { Box, styled } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetResumeLinkQuery } from '../../services/feedbackQueries';
import Popover from '../Popover/Popover';
import ResumeSkeletion from './ResumeSkeletion';

const classes = {
	modal: {
		height: '100%',
		wordBreak: 'break-all',
	},
};

const initialState = {
	link: '',
};

const DEFAULT_POSITION = {
	ATS: { x: 110, y: 150 },
	NON_ATS: { x: 50, y: 50 },
};

const StyledPdfViewer = styled(PdfViewer)(() => ({
	width: '100%',
	height: '100%',
	overflow: 'hidden',
	'& > div': {
		height: '100%',
		padding: '0px',
	},
}));

const ResumePopover = ({
	isATS,
	customerId,
	intervieweeId,
	showResumePopover,
	setShowResumePopover,
}) => {
	const { data = initialState, isPending } = useGetResumeLinkQuery(
		intervieweeId,
		customerId,
		isATS,
		showResumePopover,
	);
	const { t } = useTranslation(['resume', 'candidate-feedback']);
	// eslint-disable-next-line no-process-env
	const isProd = process.env.NODE_ENV === 'production';
	const basePath = useMemo(() => {
		if (isProd) {
			if (isATS) {
				return '/proxy/feedback/api/cdn/@icimscorp/pdf.js/3.0.6/icims';
			}
			return '/api/cdn/@icimscorp/pdf.js/3.0.6/icims';
		}
		return '/pdfjs';
	}, [isProd, isATS]);

	const file = useMemo(() => data.link || '', [data.link]);

	if (!showResumePopover) {
		return <div data-testid="empty-dom" />;
	}
	return (
		<Popover
			type="resume"
			title={t('resume')}
			showPopover={showResumePopover}
			setShowPopover={setShowResumePopover}
			defaultX={isATS ? DEFAULT_POSITION.ATS.x : DEFAULT_POSITION.NON_ATS.x}
			defaultY={isATS ? DEFAULT_POSITION.ATS.y : DEFAULT_POSITION.NON_ATS.y}
		>
			<Box sx={classes.modal}>
				{isPending ? (
					<ResumeSkeletion />
				) : (
					<StyledPdfViewer
						showSidebar
						key={file}
						loadingComponent={<ResumeSkeletion />}
						file={encodeURIComponent(`${file}`)}
						viewerPath={`${basePath}/web/minified.html`}
						pdfjsWorkerSrc={`${basePath}/build/pdf.worker.js`}
					/>
				)}
			</Box>
		</Popover>
	);
};

export default ResumePopover;
